<template>
  <div>
    <div class="footer_dummy"></div>
    <div class="columns is-mobile is-gapless footerbar has-background-white">
      <div class="column">
        <router-link to="/user">
          <div class="has-text-centered footerbar_item has-text-grey-dark">
            <b-icon icon="home" size="is-medium" v-bind:type="{'is-danger': is_home}"></b-icon>
          </div>
        </router-link>
      </div>
      <div class="column">
        <router-link to="/ranking/20401230">
          <div class="has-text-centered footerbar_item has-text-grey-dark">
            <b-icon icon="line-chart" size="is-medium" v-bind:type="{'is-danger': is_ranking}"></b-icon>
          </div>
        </router-link>
      </div>
      <div class="column">
        <router-link to="/mystock">
          <div class="has-text-centered footerbar_item has-text-grey-dark">
            <b-icon icon="book" size="is-medium" v-bind:type="{'is-danger': is_list}"></b-icon>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    is_home() {
      if(this.$route.path.includes('/user')){return true}
      else{return false}
    },
    is_list() {
      if(this.$route.path.includes('/mystock') ||
         this.$route.path.includes('/followstock') ||
         this.$route.path.includes('/stock')){return true}
      else{return false}
    },
    is_ranking() {
      if(this.$route.path.includes('/ranking')){return true}
      else{return false}
    }
  }
}
</script>

<style>
.footerbar {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 30;
  border-top-width: 2px;
  border-top-color: #eee;
  border-top-style: solid;
  width: 100vw;
}

.footerbar_item {
  padding: 0.5em;
}

.footer_dummy {
  height: 3em;
}
</style>